import type { LucideIcon } from 'lucide-react';
import { Calendar, Clock, Timer, FileText, CircleDot, MessageSquareWarning } from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const overtimeFieldIcons = {
  startDate: fieldIcon(Calendar),
  endDate: fieldIcon(Clock),
  totalHours: fieldIcon(Timer),
  description: fieldIcon(FileText),
  status: fieldIcon(CircleDot),
  rejectionReason: fieldIcon(MessageSquareWarning),
};
